import { Card, CardContent } from '@components/ui/Card';
import { BookOpen, ExternalLink, Mic2, FileText, Users } from 'lucide-react';

export default function LesezeichenPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            LeseZeichen – Bücher machen Freude
          </h1>
          <p className="text-lg text-slate-400">
            Das Mannheimer LeseZeichen entstand als Initiative einiger Literaturfreunde innerhalb
            des Aktionsbündnisses Alte Sternwarte.
          </p>
        </div>

        {/* Website Link */}
        <a
          href="https://www.lesezeichen-mannheim.de"
          target="_blank"
          rel="noopener noreferrer"
          className="block mb-8"
        >
          <div className="bg-gradient-to-r from-purple-900/20 to-blue-900/20 rounded-xl p-6 border border-purple-800/30 hover:border-purple-700/50 transition-colors">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-purple-600/10 rounded-lg flex items-center justify-center">
                  <BookOpen className="text-purple-400" size={24} />
                </div>
                <div>
                  <h2 className="text-xl font-bold text-white">www.lesezeichen-mannheim.de</h2>
                  <p className="text-slate-400">Besuchen Sie unsere Website</p>
                </div>
              </div>
              <ExternalLink className="text-purple-400" size={24} />
            </div>
          </div>
        </a>

        {/* Content */}
        <div className="space-y-6">
          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-bold text-white mb-4">Geschichte</h2>
              <p className="text-slate-300 leading-relaxed">
                Mit Lesungen und Literaturveranstaltungen sollte dem Programm in der umfassend
                sanierten Alten Sternwarte eine zusätzliche Facette hinzugefügt werden. Noch
                unter dem Namen &quot;Literatur in der Alten Sternwarte&quot; fand am 16. April
                2018 die erste Lesung mit dem Autor Uwe Timm statt.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-bold text-white mb-4">Konzept</h2>
              <p className="text-slate-300 leading-relaxed">
                Die Initiatoren des LeseZeichens haben Freude an Büchern und wollen diese mit
                anderen Menschen teilen. Sie organisieren Lesungen und bieten damit Autoren und
                Verlagen eine Plattform, ihre Werke zu präsentieren.
              </p>
            </CardContent>
          </Card>

          {/* Formats */}
          <div>
            <h2 className="text-xl font-bold text-white mb-4">Veranstaltungsformate</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Card>
                <CardContent className="p-4 text-center">
                  <div className="w-10 h-10 bg-blue-600/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <Mic2 className="text-blue-400" size={20} />
                  </div>
                  <h3 className="text-white font-semibold mb-2">Autorenlesungen</h3>
                  <p className="text-slate-400 text-sm">
                    Mit etablierten und jungen Autoren
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4 text-center">
                  <div className="w-10 h-10 bg-purple-600/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <Users className="text-purple-400" size={20} />
                  </div>
                  <h3 className="text-white font-semibold mb-2">LeseSalon</h3>
                  <p className="text-slate-400 text-sm">
                    Gäste gestalten das Programm selbst
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-4 text-center">
                  <div className="w-10 h-10 bg-amber-600/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <FileText className="text-amber-400" size={20} />
                  </div>
                  <h3 className="text-white font-semibold mb-2">Textauswahl</h3>
                  <p className="text-slate-400 text-sm">
                    Thematische Auswahl und Vorträge
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>

          <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6">
            <p className="text-slate-400 text-sm">
              Unter dem Dach des Vereins Stadtbild Mannheim e.V.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
